module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori@3x-cd57efa800bfe0089dc543733f3af014.webp";